import { render, staticRenderFns } from "./ConfirmationToken.vue?vue&type=template&id=02558273&scoped=true"
import script from "./ConfirmationToken.vue?vue&type=script&lang=js"
export * from "./ConfirmationToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02558273",
  null
  
)

export default component.exports